import styled from 'styled-components';

interface StyledCtaButtonProps {
  backgroundColor: string | null;
  isEdition: undefined | boolean;
  disabled?: boolean;
  borderRadius: string | null;
  hide?: boolean;
}

export const StyledCtaButton = styled.div<StyledCtaButtonProps>`
  height: 10vh;
  padding: 1vh 1vw;
  border-radius: 10vh;
  position: absolute;
  bottom: 5vh;
  left: 10vw;
  right: 10vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 5vw;
  cursor: pointer;

  ${({ backgroundColor }): string => {
    return backgroundColor === null
      ? ''
      : `background: ${backgroundColor};`;
  }}

  ${({ hide }): string => {
    return hide === true
      ? 'cursor: not-allowed; opacity: 0.2;'
      : '';
  }}

  ${({ disabled }): string => {
    return disabled === true
      ? 'opacity: 0.2;'
      : '';
  }}

  &:hover {
    filter: brightness(85%);
  }

  ${(props): string => {
    if (props.isEdition === true) {
      return `
        &:hover {
          -webkit-box-shadow: inset 0 0 2px 0 black;
          box-shadow: inset 0 0 2px 0 black;
        }
      `;
    }
    return '';
  }}

  ${({ borderRadius }): string => {
    return borderRadius === null
      ? ''
      : `border-radius: ${borderRadius};`;
  }}
`;
StyledCtaButton.displayName = 'StyledCtaButton';
